export default __webpack_public_path__ + "static/media/deadLink.30000ddd.png";